import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';
import { ListResponseAPI } from 'src/lib/queries';
import { Charge } from 'src/features/charges/utils/types';

const RESOURCE = '/charges/charge/';

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    customer?: string;
    subscription?: string;
    discount?: string;
    external_product_id?: string;
    external_source_id?: string;
}

const queryFn = ({ ...params }: DTO): Promise<ListResponseAPI<Charge>> => {
    return axios.get(formatResourcePath(RESOURCE), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_CHARGES_RESOURCE, useQueryHook as useListCharges };
